import React, { useState, useEffect } from 'react';
import { track } from '@vercel/analytics/react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    message: '',
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [utmParams, setUtmParams] = useState({});

  useEffect(() => {
    track('lead_form_view');
    const params = new URLSearchParams(window.location.search);
    const utms = {};
    for (const [key, value] of params.entries()) {
      if (key.startsWith('utm_')) {
        utms[key] = value;
      }
    }
    setUtmParams(utms);
  }, []);

  const formatPhoneNumber = (value) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      setFormData({ ...formData, [name]: formatPhoneNumber(value) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    track('lead_form_submit');
    setStatus({ type: 'loading', message: 'Sending...' });

    const dataToSend = { ...formData, ...utmParams, pageURL: window.location.href };

    try {
      const response = await fetch('/api/send-lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataToSend),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      setStatus({ type: 'success', message: 'Thanks! We received your request and will get back to you within 30–60 minutes.' });
      track('lead_form_success');
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
          send_to: 'AW-18050970339/GpF7CLO1lMscEOPlr59D',
          value: 1.0,
          currency: 'USD',
        });
      }
      setFormData({ name: '', phone: '', email: '', address: '', message: '' });
    } catch (error) {
      console.error('Form submission error:', error);
      setStatus({ type: 'error', message: 'Something went wrong. Please try again or call us: +1 (310) 721-7974.' });
      track('lead_form_fail');
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-content">
        <h2 className="section-title">Let’s make your home better — starting today.</h2>
        <div className="contact-form-container">
          <h3 className="form-title">Send a Message</h3>
          <form className="contact-form" onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Name*" value={formData.name} onChange={handleChange} required />
            <input type="tel" name="phone" placeholder="Phone* (###) ###-####" value={formData.phone} onChange={handleChange} required />
            <input type="email" name="email" placeholder="Email (Optional)" value={formData.email} onChange={handleChange} />
            <input type="text" name="address" placeholder="Address / ZIP Code" value={formData.address} onChange={handleChange} />
            <textarea name="message" placeholder="Message*" rows="5" value={formData.message} onChange={handleChange} required></textarea>
            <button type="submit" className="btn btn-primary" disabled={status.type === 'loading'}>
              {status.type === 'loading' ? 'Sending...' : 'Send Message'}
            </button>
          </form>
          {status.message && (
            <div className={`status-message ${status.type}`} aria-live="polite">
              {status.message}
            </div>
          )}
        </div>
        <div className="contact-details">
          <div className="map-container">
            <iframe
              src="https://maps.google.com/maps?q=17503%20Strathern%20Street%2C%20Northridge%2C%20CA%2091325&z=16&output=embed"
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="HandyFixWise Location"
            ></iframe>
          </div>
          <div className="contact-info-items">
            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <a href="tel:+13107217974" className="contact-link">+1 (310) 721-7974</a>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📍</span>
              <span>17503 Strathern Street, Northridge, CA 91325</span>
            </div>
            <div className="contact-item">
              <span className="contact-icon">⏰</span>
              <span>Mon - Sat: 9:00 AM - 7:00 PM</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
